<template>
  <v-select
    v-model="model"
    :items="items"
    item-text="name"
    item-value="warehouseId"
    return-object
    :clearable="clearable"
    :disabled="locked"
    :label="label"
  />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'WarehouseSelectComponent',
  props: {
    warehouse: {
      type: Object,
      default: null,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Warehouse',
    },
  },
  data: () => ({
    model: null,
    entries: [],
  }),
  computed: {
    items() {
      if (!this.warehouse || !this.warehouse.warehouseId
        || this.entries.some((entry) => entry.warehouseId === this.warehouse.warehouseId)) {
        return this.entries;
      }
      return [this.warehouse, ...this.entries];
    },
  },
  watch: {
    model(value) {
      this.$emit('onSetModel', value);
    },
    warehouse: {
      handler(value) {
        this.model = value;
      },
      deep: true,
    },
  },
  created() {
    this.model = this.warehouse;
    this.getWarehouses();
  },
  methods: {
    ...mapActions('apiClient', ['get']),
    getWarehouses() {
      this.get({ url: '/warehouses', params: { activeOnly: true } }).then((response) => {
        this.entries = response.data;
        if (this.warehouse) {
          this.model = this.items.find(
            (entry) => entry.warehouseId === this.warehouse.warehouseId,
          ) || this.warehouse;
        }
      });
    },
  },
};
</script>
